import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

// Globální demo režim — rozmaže čísla a jména klientů pro prezentaci třetí straně.
// Stav persistuje v localStorage a aplikuje class "demo-blur" na <body>.
// Existující CSS pravidla (.demo-blur .tabular-nums, .demo-blur .demo-sensitive ...)
// fungují automaticky na všech stránkách bez per-page wrapperu.

const STORAGE_KEY = "fw40_demo_mode";

const DemoModeContext = createContext({
  blurred: false,
  setBlurred: () => {},
  toggleBlurred: () => {},
});

export function DemoModeProvider({ children }) {
  const [blurred, setBlurredState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch { return false; }
  });

  // Aplikuj/odeber class na body při změně + persistuj
  useEffect(() => {
    if (blurred) {
      document.body.classList.add("demo-blur");
      try { localStorage.setItem(STORAGE_KEY, "1"); } catch {}
    } else {
      document.body.classList.remove("demo-blur");
      try { localStorage.setItem(STORAGE_KEY, "0"); } catch {}
    }
  }, [blurred]);

  const setBlurred = useCallback((v) => {
    setBlurredState(typeof v === "function" ? v : !!v);
  }, []);
  const toggleBlurred = useCallback(() => {
    setBlurredState((b) => !b);
  }, []);

  return (
    <DemoModeContext.Provider value={{ blurred, setBlurred, toggleBlurred }}>
      {children}
    </DemoModeContext.Provider>
  );
}

export function useDemoMode() {
  return useContext(DemoModeContext);
}
